import axios from "axios";

export function getAddressUpdateAPI(identifier, order_id) {
  return axios.get(
    `${
      process.env.REACT_APP_LOGISY_BASE_URL
    }/api/merchants/customer_update/${String(identifier)}/order/${String(
      order_id
    )}/address_update/`
  );
}

export function pincodeValidity(pincode) {
  return axios.get(
    `${process.env.REACT_APP_LOGISY_BASE_URL}/api/common/pincodes/${pincode}/`
  );
}

export function updateAddressAPI(
  identifier,
  order_id,
  pincode,
  city,
  state,
  address1,
  address2,
  landmark
) {
  return axios.post(
    `${
      process.env.REACT_APP_LOGISY_BASE_URL
    }/api/merchants/customer_update/${String(identifier)}/order/${String(
      order_id
    )}/address_update/`,
    {
      pincode,
      city,
      state,
      address1,
      address2,
      country: "India",
      landmark,
    }
  );
}
